import Image from './image.vue';
export default Image;


// WEBPACK FOOTER //
// ./src/components/image/index.js